export const INS_CURRENT_SET = 'INS_CURRENT_SET'

export const currentSet = (payload) => ({
  payload,
  type: INS_CURRENT_SET,
})
